import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faShieldAlt,
  faChartLine,
  faLayerGroup,
  faRocket,
} from '@fortawesome/free-solid-svg-icons';
import { MockGridCard, MetricRow, MetricSection } from '../shared/MockGridCard';

const WFADeepDiveCards = () => (
  <div className="space-y-4">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* WFA Validation Status */}
      <MockGridCard title="WFA Validation Status" icon={faShieldAlt} iconColor="text-blue-400">
        <div className="flex flex-col h-full">
          <div className="mb-2">
            <div className="flex items-center gap-2 mb-1">
              <FontAwesomeIcon icon={faCheckCircle} className="text-lime-200" />
              <span className="text-lg font-bold text-lime-200 uppercase tracking-wide">Pass</span>
            </div>
            <p className="text-[11px] text-gray-400 leading-tight">Forward performance retained with acceptable stability.</p>
          </div>
          <div className="mb-2">
            <MetricSection label="Validation Quality" />
            <MetricRow label="WFA Efficiency" value="0.85" />
            <MetricRow label="Performance Degradation" value="21%" />
          </div>
          <div className="mb-2">
            <MetricSection label="Outcome Context" />
            <MetricRow label="OOS Sharpe" value="1.42" muted />
            <MetricRow label="Success Rate" value="75%" muted />
          </div>
          <div className="mt-auto pt-2 border-t border-gray-700">
            <p className="text-[10px] text-gray-400 italic">Ready for live deployment via Adaptive Flow.</p>
          </div>
        </div>
      </MockGridCard>

      {/* Parameter Stability */}
      <MockGridCard title="Parameter Stability" icon={faLayerGroup} iconColor="text-purple-400">
        <div className="flex flex-col h-full">
          <MetricSection label="Drift Analysis" />
          <MetricRow label="Avg Drift" value="0.12" />
          <MetricRow label="Max Drift" value="0.28" />
          <div className="mt-3">
            <MetricSection label="Anchoring" />
            <MetricRow label="Region Stability" value="High" muted />
            <MetricRow label="Windows Anchored" value="6/8" muted />
          </div>
          <div className="mt-auto pt-2 border-t border-gray-700">
            <p className="text-[10px] text-gray-400 italic">Low drift indicates consistent structural edge.</p>
          </div>
        </div>
      </MockGridCard>

      {/* Performance Consistency */}
      <MockGridCard title="Performance Consistency" icon={faChartLine} iconColor="text-green-400">
        <div className="flex flex-col h-full">
          <MetricSection label="Return Distribution" />
          <MetricRow label="CV" value="0.31" />
          <MetricRow label="Trend" value="Stable" />
          <div className="mt-3">
            <MetricSection label="Win Rate Stability" />
            <MetricRow label="Range" value="52-61%" muted />
            <MetricRow label="Variance" value="Low" muted />
          </div>
          <div className="mt-auto pt-2 border-t border-gray-700">
            <p className="text-[10px] text-gray-400 italic">Consistent performance across windows.</p>
          </div>
        </div>
      </MockGridCard>

      {/* Live Readiness */}
      <MockGridCard title="Live Readiness" icon={faRocket} iconColor="text-cyan-400">
        <div className="flex flex-col h-full">
          <div className="flex items-center gap-2 mb-3">
            <span className="px-2 py-1 rounded text-[10px] uppercase tracking-wide bg-lime-300/10 text-lime-200 font-semibold">Eligible</span>
          </div>
          <MetricSection label="Deployment Criteria" />
          <div className="space-y-1 text-xs">
            <div className="flex justify-between"><span className="text-gray-400">WFA Validated</span><FontAwesomeIcon icon={faCheckCircle} className="text-green-400 text-[10px]" /></div>
            <div className="flex justify-between"><span className="text-gray-400">Stability Confirmed</span><FontAwesomeIcon icon={faCheckCircle} className="text-green-400 text-[10px]" /></div>
            <div className="flex justify-between"><span className="text-gray-400">Risk Bounded</span><FontAwesomeIcon icon={faCheckCircle} className="text-green-400 text-[10px]" /></div>
            <div className="flex justify-between"><span className="text-gray-400">Sufficient Depth</span><FontAwesomeIcon icon={faCheckCircle} className="text-green-400 text-[10px]" /></div>
          </div>
          <div className="mt-auto pt-2 border-t border-gray-700">
            <p className="text-[10px] text-gray-400 italic">Strategy meets all deployment criteria.</p>
          </div>
        </div>
      </MockGridCard>
    </div>
  </div>
);

export default WFADeepDiveCards;
